<ng-container [formGroup]="formGroup">

    <mat-form-field class="form-field" [appearance]="appearance">
        
        <mat-label>
            {{label}}
        </mat-label>

        <mat-select formControlName="priority">

            <mat-option *ngFor="let priority of priorities" [value]="priority.priorityid">
                {{priority.priorityname}}
            </mat-option>

            <mat-option [value]="null">
                Kein Wert
            </mat-option>

        </mat-select>

    </mat-form-field>

</ng-container>